export default __webpack_public_path__ + "static/media/step8-5.b108e5f0.png";